var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.6,
    height: 75.593,
    viewBox: "0 0 75.6 75.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2575",
    "data-name": "Group 2575",
    transform: "translate(20224 905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M37.287,62.485l-25.2-25.2,25.2-25.2Z",
    transform: "translate(-20210.891 -891.891)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M49.378,0V50.4H49.37L24.176,75.589v-50.4Z",
    transform: "translate(-20197.779 -905)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M25.194,0V50.4L0,75.589v-50.4Z",
    transform: "translate(-20224 -905)",
    fill: "#9734eb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSign);
export default __webpack_public_path__ + "static/media/logo-sign.da38bc66803be2be2e427bd093072881.svg";
export { ForwardRef as ReactComponent };